package com.gsb.vyapar.bhagya.presentation.business.view

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.Card
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.draw.clip
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.domain.getAddress
import com.gsb.vyapar.bhagya.domain.getDescription
import com.gsb.vyapar.bhagya.domain.getEmail
import com.gsb.vyapar.bhagya.domain.getFacebook
import com.gsb.vyapar.bhagya.domain.getId
import com.gsb.vyapar.bhagya.domain.getImage1
import com.gsb.vyapar.bhagya.domain.getImage2
import com.gsb.vyapar.bhagya.domain.getImage3
import com.gsb.vyapar.bhagya.domain.getImage4
import com.gsb.vyapar.bhagya.domain.getImage5
import com.gsb.vyapar.bhagya.domain.getImages
import com.gsb.vyapar.bhagya.domain.getInstagram
import com.gsb.vyapar.bhagya.domain.getLatitude
import com.gsb.vyapar.bhagya.domain.getLinkedIn
import com.gsb.vyapar.bhagya.domain.getLogo
import com.gsb.vyapar.bhagya.domain.getLongitude
import com.gsb.vyapar.bhagya.domain.getMap
import com.gsb.vyapar.bhagya.domain.getPhone1
import com.gsb.vyapar.bhagya.domain.getPhone2
import com.gsb.vyapar.bhagya.domain.getRegistrationNumber
import com.gsb.vyapar.bhagya.domain.getServices
import com.gsb.vyapar.bhagya.domain.getWebsite
import com.gsb.vyapar.bhagya.domain.getX
import com.gsb.vyapar.bhagya.domain.getYoutube
import com.gsb.vyapar.bhagya.domain.isBusinessDeleted
import com.gsb.vyapar.bhagya.domain.showGallery
import com.gsb.vyapar.bhagya.domain.showSocialLinks
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.interactor.util.showError
import com.gsb.vyapar.bhagya.presentation.auth.util.isUserAdmin
import com.gsb.vyapar.bhagya.presentation.business.uistate.getBusinessUiState
import com.gsb.vyapar.bhagya.presentation.business.util.getLatestBusiness
import com.gsb.vyapar.bhagya.presentation.business.util.isMyBusiness
import com.gsb.vyapar.bhagya.presentation.business.util.launchAddEditMBusiness
import com.gsb.vyapar.bhagya.presentation.business.util.showGallery
import com.gsb.vyapar.bhagya.presentation.common.button.GVBButtonReport
import com.gsb.vyapar.bhagya.presentation.common.image.BusinessCardPlaceHolder
import com.gsb.vyapar.bhagya.presentation.common.image.CommonImage
import com.gsb.vyapar.bhagya.presentation.common.image.PlaceHolder
import com.gsb.vyapar.bhagya.presentation.common.image.SmoothImage
import com.gsb.vyapar.bhagya.presentation.common.text.*
import com.gsb.vyapar.bhagya.presentation.common.toolbar.Toolbar
import com.gsb.vyapar.bhagya.presentation.common.toolbar.ToolbarEdit
import com.gsb.vyapar.bhagya.presentation.navigation.util.popView
import com.gsb.vyapar.bhagya.presentation.navigation.view.AboutGSBVyaparBhagyaView
import com.gsb.vyapar.bhagya.presentation.navigation.view.BusinessLocationPin
import com.gsb.vyapar.bhagya.presentation.navigation.view.PlatformBusinessMap
import com.gsb.vyapar.bhagya.theme.*
import com.gsb.vyapar.bhagya.util.getEmail
import com.gsb.vyapar.bhagya.util.getEncodedMessage
import com.gsb.vyapar.bhagya.util.getMobile
import com.gsb.vyapar.bhagya.util.BuildConfig
import com.gsb.vyapar.bhagya.util.PlatformType

@Composable
fun BusinessDetailView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    val business = getBusinessUiState().isBusinessFetched.value[uiState.businessUiState.business.getId()] ?: uiState.businessUiState.business
    val state = rememberSaveable(business.getId(), saver = ScrollState.Saver) { ScrollState(getBusinessUiState().businessDetailScroll) }
    var isMapInteracting by remember { mutableStateOf(false) }
    val uriHandler = LocalUriHandler.current
    val businessLatitude = business.getLatitude().toDoubleOrNull()
    val businessLongitude = business.getLongitude().toDoubleOrNull()
    val hasValidCoordinates = businessLatitude != null && businessLongitude != null && (businessLatitude != 0.0 || businessLongitude != 0.0)
    val isMapSupported = BuildConfig.platform() == PlatformType.ANDROID || BuildConfig.platform() == PlatformType.IOS || BuildConfig.platform() == PlatformType.JS || BuildConfig.platform() == PlatformType.DESKTOP

    Surface(
        modifier = Modifier.fillMaxSize(),
        color = MaterialTheme.colors.background
    ) {
        Column(
            modifier = Modifier.fillMaxWidth()
        ) {
            if (isMyBusiness(business) || isUserAdmin()) {
                ToolbarEdit("Business Details") {
                    launchAddEditMBusiness(business)
                }
            } else {
                Toolbar("Business Details")
            }
            Column(Modifier.verticalScroll(state, enabled = !isMapInteracting).padding(all = 16.dp)) {
                BusinessCardFull(uiState, onTriggerEvent, business) {
                    getBusinessUiState().updateBusinessDetailScroll(state.value)
                    showGallery(listOf(business.getLogo()), 0)
                }
                Spacer(Modifier.height(12.dp))
                Card(
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(8.dp),
                    backgroundColor = offwhite,
                ) {
                    Column(modifier = Modifier.fillMaxWidth().padding(16.dp)) {
                        Text18SemiBold("About :", black)
                        Spacer(Modifier.height(8.dp))
                        Row {
                            BusinessCardPlaceHolder(info)
                            Spacer(Modifier.width(8.dp))
                            Column {
                                Text14RegularBB("Description", black)
                                Text14RegularBBStart(business.getDescription(), black)
                            }
                        }
                        Spacer(Modifier.height(5.dp))
                        Row {
                            BusinessCardPlaceHolder(service)
                            Spacer(Modifier.width(8.dp))
                            Column {
                                Text14RegularBB("Services", black)
                                Text14RegularBBStart(business.getServices(), black)
                            }
                        }
                    }
                }
                Spacer(Modifier.height(12.dp))
                Card(
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(8.dp),
                    backgroundColor = offwhite,
                ) {
                    Column(modifier = Modifier.fillMaxWidth().padding(16.dp)) {
                        Text18SemiBold("Contact Details :", black)
                        Spacer(Modifier.height(8.dp))
                        Row(verticalAlignment = Alignment.CenterVertically) {
                            BusinessCardPlaceHolder(address)
                            Spacer(Modifier.width(8.dp))
                            Column {
                                Text14RegularBB("Address", black)
                                Text14RegularBBStart(business.getAddress(), black)
                            }
                        }
                        Spacer(Modifier.height(5.dp))
                        Row(verticalAlignment = Alignment.CenterVertically) {
                            BusinessCardPlaceHolder(call)
                            Spacer(Modifier.width(8.dp))
                            Column {
                                Text14RegularBB("Phone1", black)
                                Text14RegularBBStart(business.getPhone1(), Color.Blue, Modifier.clickable { uriHandler.openUri("tel:${business.getPhone1()}") })
                            }
                        }
                        if (business.getPhone2().isNotEmpty()) {
                            Spacer(Modifier.height(5.dp))
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                BusinessCardPlaceHolder(call)
                                Spacer(Modifier.width(8.dp))
                                Column {
                                    Text14RegularBB("Phone2", black)
                                    Text14RegularBBStart(business.getPhone2(), Color.Blue, Modifier.clickable { uriHandler.openUri("tel:${business.getPhone2()}") })
                                }
                            }
                        }
                        Spacer(Modifier.height(5.dp))
                        Row(verticalAlignment = Alignment.CenterVertically) {
                            BusinessCardPlaceHolder(mail)
                            Spacer(Modifier.width(8.dp))
                            Column {
                                Text14RegularBB("Email", black)
                                Text14RegularBBStart(business.getEmail(), Color.Blue, Modifier.clickable { uriHandler.openUri("mailto:${business.getEmail()}") })
                            }
                        }
                        Spacer(Modifier.height(5.dp))
                        Row(verticalAlignment = Alignment.CenterVertically) {
                            BusinessCardPlaceHolder(whatsapp)
                            Spacer(Modifier.width(8.dp))
                            Column {
                                Text14RegularBB("Whatsapp", black)
                                Text14RegularBBStart(business.getPhone1(), Color.Blue, Modifier.clickable { uriHandler.openUri("https://wa.me/+91${business.getPhone1()}") })
                            }
                        }
                        if (business.getPhone2().isNotEmpty()) {
                            Spacer(Modifier.height(5.dp))
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                BusinessCardPlaceHolder(whatsapp)
                                Spacer(Modifier.width(8.dp))
                                Column {
                                    Text14RegularBB("Whatsapp", black)
                                    Text14RegularBBStart(business.getPhone2(), Color.Blue, Modifier.clickable { uriHandler.openUri("https://wa.me/+91${business.getPhone2()}") })
                                }
                            }
                        }
                        if (business.getWebsite().isNotEmpty()) {
                            Spacer(Modifier.height(5.dp))
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                BusinessCardPlaceHolder(web)
                                Spacer(Modifier.width(8.dp))
                                Column {
                                    Text14RegularBB("Website", black)
                                    Text14RegularBBStart(business.getWebsite(), Color.Blue, Modifier.clickable { uriHandler.openUri(business.getWebsite()) })
                                }
                            }
                        }
                        if (business.getMap().isNotEmpty()) {
                            Spacer(Modifier.height(5.dp))
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                BusinessCardPlaceHolder(googlemaps)
                                Spacer(Modifier.width(8.dp))
                                Column {
                                    Text14RegularBB("Maps", black)
                                    Text14RegularBBStart(business.getMap(), Color.Blue, Modifier.clickable { uriHandler.openUri(business.getMap()) })
                                }
                            }
                        }
                    }
                }
                if (hasValidCoordinates && isMapSupported) {
                    Spacer(Modifier.height(12.dp))
                    Card(
                        modifier = Modifier.fillMaxWidth(),
                        shape = RoundedCornerShape(8.dp),
                        backgroundColor = offwhite,
                    ) {
                        Column(modifier = Modifier.fillMaxWidth().padding(16.dp)) {
                            Text18SemiBold("View in Map :", black)
                            Spacer(Modifier.height(12.dp))
                            Box(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .height(400.dp)
                                    .clip(RoundedCornerShape(8.dp))
                            ) {
                                PlatformBusinessMap(
                                    modifier = Modifier.fillMaxSize(),
                                    businessLocations = listOf(
                                        BusinessLocationPin(
                                            business = business,
                                            latitude = businessLatitude!!,
                                            longitude = businessLongitude!!
                                        )
                                    ),
                                    uiState = uiState,
                                    onTriggerEvent = onTriggerEvent,
                                    onInteractionChanged = { interacting ->
                                        if (isMapInteracting != interacting) {
                                            isMapInteracting = interacting
                                        }
                                    },
                                    enableUserLocation = false,
                                )
                            }
                        }
                    }
                }
                if (business.showGallery()) {
                    Spacer(Modifier.height(12.dp))
                    Card(
                        modifier = Modifier.fillMaxWidth(),
                        shape = RoundedCornerShape(8.dp),
                        backgroundColor = offwhite,
                    ) {
                        Column(modifier = Modifier.fillMaxWidth().padding(16.dp)) {
                            Text18SemiBold("Gallery :", black)
                            Spacer(Modifier.height(8.dp))
                            LazyRow(
                                modifier = Modifier.fillMaxWidth().padding(4.dp),
                                horizontalArrangement = Arrangement.spacedBy(12.dp)
                            ) {
                                if (business.getImage1().isNotEmpty()) {
                                    item {
                                        SmoothImage(
                                            uiState.getImage(business.getImage1()),
                                            width = 200.dp,
                                            height = 200.dp,
                                            modifier = Modifier.clickable {
                                                getBusinessUiState().updateBusinessDetailScroll(state.value)
                                                showGallery(business.getImages(), 0)
                                            }
                                        )
                                    }
                                }
                                if (business.getImage2().isNotEmpty()) {
                                    item {
                                        SmoothImage(
                                            uiState.getImage(business.getImage2()),
                                            width = 200.dp,
                                            height = 200.dp,
                                            modifier = Modifier.clickable {
                                                getBusinessUiState().updateBusinessDetailScroll(state.value)
                                                showGallery(business.getImages(), 1)
                                            }
                                        )
                                    }
                                }
                                if (business.getImage3().isNotEmpty()) {
                                    item {
                                        SmoothImage(
                                            uiState.getImage(business.getImage3()),
                                            width = 200.dp,
                                            height = 200.dp,
                                            modifier = Modifier.clickable {
                                                getBusinessUiState().updateBusinessDetailScroll(state.value)
                                                showGallery(business.getImages(), 2)
                                            }
                                        )
                                    }
                                }
                                if (business.getImage4().isNotEmpty()) {
                                    item {
                                        SmoothImage(
                                            uiState.getImage(business.getImage4()),
                                            width = 200.dp,
                                            height = 200.dp,
                                            modifier = Modifier.clickable {
                                                getBusinessUiState().updateBusinessDetailScroll(state.value)
                                                showGallery(business.getImages(), 3)
                                            }
                                        )
                                    }
                                }
                                if (business.getImage5().isNotEmpty()) {
                                    item {
                                        SmoothImage(
                                            uiState.getImage(business.getImage5()),
                                            width = 200.dp,
                                            height = 200.dp,
                                            modifier = Modifier.clickable {
                                                getBusinessUiState().updateBusinessDetailScroll(state.value)
                                                showGallery(business.getImages(), 4)
                                            }
                                        )
                                    }
                                }
                            }
                        }
                    }
                }
                if (business.showSocialLinks()) {
                    Spacer(Modifier.height(12.dp))
                    Card(
                        modifier = Modifier.fillMaxWidth(),
                        shape = RoundedCornerShape(8.dp),
                        backgroundColor = offwhite,
                    ) {
                        Column(modifier = Modifier.fillMaxWidth().padding(16.dp)) {
                            Text18SemiBold("Social Links :", black)
                            if (business.getFacebook().isNotEmpty()) {
                                Spacer(Modifier.height(5.dp))
                                Row(verticalAlignment = Alignment.CenterVertically) {
                                    BusinessCardPlaceHolder(facebook)
                                    Spacer(Modifier.width(8.dp))
                                    Column {
                                        Text14RegularBB("Facebook", black)
                                        Text14RegularBBStart(business.getFacebook(), Color.Blue, Modifier.clickable { uriHandler.openUri(business.getFacebook()) })
                                    }
                                }
                            }
                            if (business.getInstagram().isNotEmpty()) {
                                Spacer(Modifier.height(5.dp))
                                Row(verticalAlignment = Alignment.CenterVertically) {
                                    BusinessCardPlaceHolder(instagram)
                                    Spacer(Modifier.width(8.dp))
                                    Column {
                                        Text14RegularBB("Instagram", black)
                                        Text14RegularBBStart(business.getInstagram(), Color.Blue, Modifier.clickable { uriHandler.openUri(business.getInstagram()) })
                                    }
                                }
                            }
                            if (business.getX().isNotEmpty()) {
                                Spacer(Modifier.height(5.dp))
                                Row(verticalAlignment = Alignment.CenterVertically) {
                                    BusinessCardPlaceHolder(twitter)
                                    Spacer(Modifier.width(8.dp))
                                    Column {
                                        Text14RegularBB("X", black)
                                        Text14RegularBBStart(business.getX(), Color.Blue, Modifier.clickable { uriHandler.openUri(business.getX()) })
                                    }
                                }
                            }
                            if (business.getLinkedIn().isNotEmpty()) {
                                Spacer(Modifier.height(5.dp))
                                Row(verticalAlignment = Alignment.CenterVertically) {
                                    BusinessCardPlaceHolder(linkedin)
                                    Spacer(Modifier.width(8.dp))
                                    Column {
                                        Text14RegularBB("LinkedIn", black)
                                        Text14RegularBBStart(business.getLinkedIn(), Color.Blue, Modifier.clickable { uriHandler.openUri(business.getLinkedIn()) })
                                    }
                                }
                            }
                            if (business.getYoutube().isNotEmpty()) {
                                Spacer(Modifier.height(5.dp))
                                Row(verticalAlignment = Alignment.CenterVertically) {
                                    BusinessCardPlaceHolder(youtube)
                                    Spacer(Modifier.width(8.dp))
                                    Column {
                                        Text14RegularBB("Youtube", black)
                                        Text14RegularBBStart(business.getYoutube(), Color.Blue, Modifier.clickable { uriHandler.openUri(business.getYoutube()) })
                                    }
                                }
                            }
                        }
                    }
                }
                Spacer(Modifier.height(12.dp))
                Card(
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(8.dp),
                    backgroundColor = offwhite,
                ) {
                    Column(modifier = Modifier.fillMaxWidth().padding(16.dp)) {
                        Text14RegularBB("Dear GSB Samaj Bhandhavas, if you come across any incorrect details while contacting, please report this business. Help us keep the information accurate for our community.", black)
                        Spacer(Modifier.height(16.dp))
                        GVBButtonReport(text = "Report Business via Whatsapp") {
                            uriHandler.openUri("https://wa.me/+91${getMobile()}?text=${getEncodedMessage("Report Business - ${business.getRegistrationNumber()} \n\nPlease write your query or concern about this business below (e.g., incorrect details, fake business, etc. :\n\n")}")
                        }
                        Spacer(Modifier.height(16.dp))
                        GVBButtonReport(text = "Report Business via Email") {
                            uriHandler.openUri("mailto:${getEmail()}?subject=${getEncodedMessage("Report Business - ${business.getRegistrationNumber()}")}&body=${getEncodedMessage("Please write your query or concern about this business below (e.g., incorrect details, fake business, etc. :\n\n")}")
                        }
                    }
                }
                Spacer(Modifier.height(12.dp))
                AboutGSBVyaparBhagyaView(uiState, onTriggerEvent)
            }
        }
    }
    LaunchedEffect(Unit) {
        if (business.isBusinessDeleted()) {
            popView()
            showError("This business has been deleted and is no longer available.")
        } else {
            getLatestBusiness(business) {
                if (it?.isBusinessDeleted() == true) {
                    popView()
                    showError("This business has been deleted and is no longer available.")
                }
            }
        }
    }
}
